import React, { useState } from "react";
import { useSearchParams } from "react-router-dom";
import ChatListUI from "./ChatListUI";
import { useUserChats } from "../../../../api/Chats/chats";
import Message from "./Message";

export default function ChatLayout() {
  const [params] = useSearchParams();
  const userId = params.get("userId");

  const { data: chats = [], isLoading } = useUserChats(userId);

  const [selectedChat, setSelectedChat] = useState(null);

  let employeeName = "Unknown Employee";
  if (chats.length > 0) {
    const user = chats[0].users.find((u) => u._id === userId);
    if (user) {
      employeeName =
        `${user.firstName || ""} ${user.lastName || ""}`.trim() ||
        user.username;
    }
  }

  return (
    <div className="flex flex-col h-screen bg-white">
      {/* Header */}
      <div className="p-4 border-b border-gray-200 font-semibold text-lg">
        Employee name: {employeeName}
      </div>

      <div className="flex flex-1 overflow-hidden">
        {/* Left sidebar: Chat List */}
        <div className="w-1/3 border-r border-gray-200">
          <ChatListUI
            chats={chats}
            isLoading={isLoading}
            currentUserId={userId}
            onSelectChat={(chat) => setSelectedChat(chat)}
            selectedChatId={selectedChat?._id}
          />
        </div>

        {/* Right side: Messages */}
        <div className="flex-1">
          <Message 
            chatId={selectedChat?._id} 
            currentUserId={userId} 
            isGroupChat={selectedChat?.isGroupChat || false} 
          />
        </div>
      </div>
    </div>
  );
}